const { dataLayer } = window; // dataLayer is from Google Tag Manager

const internals = {};

/************

SOMETHING NOT WORKING WITH THIS?
Use the GTM Debugger
https://www.analyticsmania.com/post/how-to-check-if-google-tag-manager-is-working/

************/

exports.event = (gtmEvent, userId) => {
    // Allow tracking on non-prod environments only if environment
    // is configured to do so. To be used only when testing our GTM
    // integration and turned off otherwise
    // UNLESS client has configured a QA User Id view set to receive
    // only data from the QA site
    // and the production view is configured to filter out any data NOT from the production site
    // Check GA Admin to figure this out (bug client for access as needed)
    if (process.env.NODE_ENV !== "production" && !process.env.GTM_TEST) {
        return null;
    }

    dataLayer.push({
        ...internals.gtmEvents[gtmEvent],
        userId
    });
};

// Fire when a user confirms their payment option (clicks "Next" in purchase dialog with their option selected)
exports.checkout = (purchaseOption, userId) => {
    if (process.env.NODE_ENV !== "production" && !process.env.GTM_TEST) {
        return null;
    }

    dataLayer.push({
        ...internals.gtmEvents.selectPurchaseOption,
        ecommerce: {
            checkout: {
                actionField: { step: 1 },
                products: [
                    {
                        name: purchaseOption.description,
                        id: purchaseOption.id,
                        price: (purchaseOption.cost / 100).toFixed(2),
                        brand: "MyBodyModel",
                        category: "Credits",
                        quantity: 1
                    }
                ]
            }
        },
        userId
    });
};

// Fire when a user purchases credits
exports.purchase = (purchaseOption, userId) => {
    if (process.env.NODE_ENV !== "production" && !process.env.GTM_TEST) {
        return null;
    }

    dataLayer.push({
        ...internals.gtmEvents.completePurchase,
        ecommerce: {
            purchase: {
                actionField: {
                    id: internals.transactionId(), // Transaction ID. Required for purchases and refunds.
                    affiliation: "MyBodyModel Website",
                    revenue: (purchaseOption.cost / 100).toFixed(2) // Total transaction value (incl. tax and shipping)
                },
                products: [
                    {
                        name: purchaseOption.description,
                        id: purchaseOption.id,
                        price: (purchaseOption.cost / 100).toFixed(2),
                        brand: "MyBodyModel",
                        category: "Credits",
                        quantity: 1
                    }
                ]
            }
        },
        userId
    });
};

internals.gtmEvents = {
    newUser: {
        event: "newAccountCreated"
    },

    newBodyModel: {
        event: "newBodyModelCreated"
    },

    openPurchaseModal: {
        event: "purchaseOverlay_step_1"
    },

    selectPurchaseOption: {
        event: "purchaseOverlay_step_2"
    },

    completePurchase: {
        event: "purchaseOverlay_step_3"
    }
};

/*
DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
                    Version 2, December 2004

 Copyright (C) 2011 Jed Schmidt <http://jed.is>

 Everyone is permitted to copy and distribute verbatim or modified
 copies of this license document, and changing it is allowed as long
 as the name is changed.

            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
   TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION

  0. You just DO WHAT THE FUCK YOU WANT TO.
*/
/*
    Bic'd from https://gist.github.com/jed/982883
    A UUID-generating function for creating unique ids for the transactions we send
    to Google Analytics via Google Tag Manager
    This is kinda horrific, product of being overbudget
    Better way would be to create a new table on the API side for storing transactions,
    returning those ids to the frontend and setting them here
    (and setting them on the orders we send to Mailchim, too)
    But over-budget is more compelling than better, so here we are
*/
internals.transactionId = () => {
    const b = a => {
        return a
            ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
            : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, b);
    };
    return b();
};



// WEBPACK FOOTER //
// ./src/utils/gtm-custom.js